exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-option[data-v-51af3b88] {\n  display: inline-block;\n  margin-left: 5px;\n  height: 45px\n}\n", ""]);

// exports
